import { SupportEmailLink } from "components/app/support-email-link";
import { InlineBanner } from "components/ui/inline-banner";
import React from "react";

interface DirectEmailSetupBannerProps {
    className?: string;
}

export const DirectEmailSetupBanner: React.FC<DirectEmailSetupBannerProps> = ({
    className,
}) => {
    return (
        <InlineBanner type="info">
            Your SignWise emails will come from communications@findassistedliving.org. To
            boost deliverability and send SignWise emails from your agency&apos;s domain,{" "}
            {SupportEmailLink({
                label: "Contact Support",
                subject: "Direct Email Setup",
            })}
        </InlineBanner>
    );
};
